// El filtro por etiqueta, con la opcion "Sin etiqueta".
//
// Lissette, 2026-09-08: *"quisiera filtrar las etiquetas personalizadas
// tambien por la que no tiene, es decir sin etiquetas"*. En Polizas esa
// opcion ya existia; en Clientes no, y ademas cada pantalla llevaba su propia
// copia de la cuenta y de la comparacion. Copiar la de Polizas habria dejado
// dos versiones que se arreglan por separado — que es justo como entra la
// duplicacion (CLAUDE.md, "Search before creating"). Aqui vive una sola,
// sin nada de pantalla, para poder probarla sin montar React.

/** Valor del desplegable que significa "los que no tienen ninguna etiqueta". */
export const SIN_ETIQUETA = 'none';

/**
 * Las etiquetas de una ficha, ya limpias.
 *
 * Una etiqueta que quedo en blanco o con solo espacios NO cuenta: por dentro
 * la ficha tendria `tags: ["  "]` y por fuera no se ve ninguna, asi que
 * tratarla como etiquetada la escondia del filtro "Sin etiqueta" sin que nada
 * en pantalla lo explicara.
 */
export function etiquetasDe(ficha) {
  const crudas = ficha && Array.isArray(ficha.tags) ? ficha.tags : [];
  return crudas.map((t) => String(t == null ? '' : t).trim()).filter(Boolean);
}

/**
 * Las opciones del desplegable, con cuantas fichas hay en cada una.
 *
 * Se agrupa sin distinguir mayusculas —igual que se deduplica al ponerlas— para
 * que "Renovar" y "renovar" sean UNA opcion y no dos que se reparten la lista.
 * Se enseña la primera forma que aparecio.
 *
 * El numero cuenta FICHAS, no veces: una etiqueta repetida dentro de la misma
 * ficha suma una sola vez, para que el numero del desplegable sea exactamente
 * la cantidad de filas que veras al elegirlo. Antes sumaba apariciones y una
 * etiqueta duplicada prometia mas resultados de los que salian.
 */
export function contarEtiquetas(fichas) {
  const porMinuscula = new Map(); // minusculas -> { label, n }
  let sinEtiqueta = 0;
  for (const ficha of (fichas || [])) {
    const etiquetas = etiquetasDe(ficha);
    if (!etiquetas.length) { sinEtiqueta += 1; continue; }
    const yaContadas = new Set();
    for (const label of etiquetas) {
      const k = label.toLowerCase();
      if (yaContadas.has(k)) continue;
      yaContadas.add(k);
      const actual = porMinuscula.get(k);
      if (actual) actual.n += 1; else porMinuscula.set(k, { label, n: 1 });
    }
  }
  return {
    opciones: [...porMinuscula.values()].sort((a, b) => a.label.localeCompare(b.label)),
    sinEtiqueta,
  };
}

/** ¿Esta ficha pasa el filtro de etiqueta elegido? Vacio o 'all' = todas. */
export function pasaElFiltroDeEtiqueta(ficha, filtro) {
  if (!filtro || filtro === 'all') return true;
  const etiquetas = etiquetasDe(ficha);
  if (filtro === SIN_ETIQUETA) return etiquetas.length === 0;
  const buscada = String(filtro).toLowerCase();
  return etiquetas.some((t) => t.toLowerCase() === buscada);
}

/** El texto de la opcion "Sin etiqueta", con su numero. */
export function textoSinEtiqueta(n, lang) {
  return `${lang === 'es' ? 'Sin etiqueta' : 'Untagged'} (${n})`;
}
